import { Element, Node } from 'slate';
import { RenderElementProps } from 'slate-react';
import { CustomEditor, CustomElement, TableOfContentElement } from 'slate/types/slate';
import { TableOfContent } from './components/TableOfContent';

const isTableOfContent = (node: Node): node is TableOfContentElement => Element.isElement(node) && node.type === 'table-of-content';

const withTableOfContent =
  (options: { readOnly?: boolean; hasWritePermission?: boolean } = {}) =>
  (editor: CustomEditor) => {
    const { renderElement, isVoid } = editor;
    editor.isVoid = (element: CustomElement) => isTableOfContent(element) || isVoid(element);

    editor.renderElement = (props: RenderElementProps) => {
      if (isTableOfContent(props.element)) {
        return <TableOfContent {...props} readOnly={options.readOnly} hasWritePermission={options.hasWritePermission} />;
      } else {
        return renderElement(props);
      }
    };

    return editor;
  };

export default withTableOfContent;
